import Image from 'next/image';

const TableItem = ({ children, path, alt, className }) => {
  if (path) {
    return (
      <div
        className={className}
        itemScope
        itemType='http://schema.org/ListItem'
      >
        <Image src={path} alt={alt} title={alt} loading='lazy' layout='fill' />
        <span>{children}</span>
      </div>
    );
  }
  return <div className={className}>{children}</div>;
};

export default TableItem;
